import { FETCH_BOOKINGS_SUCCESS } from '@redux/bookings';
import type { Dispatch } from '@typings/redux';
import type { Booking } from '@typings/redux/bookings';
import WeddingSDK from '@xo-union/sdk-weddings';
import { useCallback, useMemo } from 'react';

export const useUnbookVendor = (
	dispatch: Dispatch,
	vendor: Vendor.Decorated | null,
	bookings: Booking[],
	sessionToken: string | null,
) => {
	const weddingSdk = new WeddingSDK({
		apiKey: process.env.WEDDINGS_API_KEY as string,
		membershipSessionToken: sessionToken as string,
	});

	const bookingPayload = useMemo(
		() => bookings.find((booking) => booking.vendorId === vendor?.id),
		[bookings, vendor],
	);

	return useCallback(async () => {
		if (!bookingPayload || !weddingSdk) return;

		return weddingSdk.deleteBooking(bookingPayload.bookingId).then(() => {
			const bookingsToUpdate = bookings.filter(
				(booking) => booking.bookingId !== bookingPayload.bookingId,
			);
			dispatch({
				type: FETCH_BOOKINGS_SUCCESS,
				bookings: bookingsToUpdate,
			});
		});
	}, [weddingSdk, dispatch, bookingPayload, bookings]);
};
